require('lib/view_helper')
var app = require('application')

// Classe de base pour toutes les vues.  Presque pile
// celle de brunch.io (on a juste ajouté le _.defer pour
// régler automatiquement toute une catégorie de bugs,
// et initialisé la langue de Moment.js).
module.exports = Backbone.View.extend({
  events: {
    'click ul.pagination a': 'goToPage', // Gère la pagination du listing
    'change ul.pagination select.page': 'goToPage', // Gère la pagination du listing
    'click th.sortable div': 'addSort', // Gère la pagination du listing
    'keydown #search-ui': 'processSearch', // Gère la recherche rapide sur le listing
    'click .searchReset': 'resetSearch', // Gère le reset de la recherche rapide sur le listing
    "click button[data-action='delete']": 'delete', // Clic sur le bouton DELETE - supprime une ligne
    'click .filters': 'processFilter', // Déclenchament de filtre sur le listing
    'click .dropdown-submenu>a': 'toggleDropdownSubmenu',
    'click .next-el': 'nextElement', // BOuton élément suivant
    'click .previous-el': 'previousElement', // BOuton élément précédent
    'click .multiSelection': 'toggleSelection', // BOuton élément précédent
    'click .delete-selection': 'deleteSelection', // Changement de valeur dans les champs de temps
    'click .show-modal': 'show_modal', // Accès a la modal

    'click .user-profil': 'userModal',

    'click button.click2call': 'createCall',
    'click a.click2call': 'createCall', // Lance un appel
    'click button.refresh-list': 'list',
    'click #no-limit-list #no-limit-checkbox': 'list',
    'click .download-file': 'downloadFile'
  },
  filter: {},
  name: 'view',
  setFilter (champs, value) {

  },
  processFilter (e) {
    this.list()
  },
  initialize (opts) {
    this.page = 0
    this.filters = [] // Reset des filtres affecté
    if (opts) {
      if (opts.name) this.name = opts.name // N?ommage de la vue pour le debug
    }

    _.bindAll(this, 'template', 'getRenderData', 'render', 'afterRender')
  },
  defaultSearchElem: '#search-ui',
  backToHome_click () {
    window.location = '#'
  },
  template () {},
  getRenderData () {},
  session: {},
  setSession (session) {
    this.session = session
  },
  render (event, id) {
    this.$el.html(this.template(this.getRenderData()))
    _.defer(this.afterRender, event, id)
    this.delegateEvents()
    return this
  },
  paramsURL: {},
  getParamsURL (param) {
    if (this.paramsURL && this.paramsURL[param]) {
      return this.paramsURL[param]
    }
  },
  setParamsURL (paramsURL) {
    this.paramsURL = paramsURL
  },
  afterRender (event, id) {
    this.rendered = true
    $('.dropdown-toggle').dropdown()

    this.initButtonCheckbox()

    switch (event) {
      case 'new':
      case 'update':
        if (typeof (this.form) === 'function') this.form(id)
        else console.warn("Pas de fonction 'form' dans la vue : " + this.name)
        break
      case 'select':
        if (typeof (this.select) === 'function') this.select(id)
        else console.warn("Pas de fonction 'select' dans la vue : " + this.name)
        break
      default:
        if (typeof (this.list) === 'function') {
          if (this.paramsURL && this.paramsURL.filter) {
            var f = this.paramsURL.filter
              // this.paramsURL.filter = false;
            this.quickFilter(f)
          }
          this.list()
        } else console.warn("Pas de fonction 'list' dans la vue : " + this.name)
        break

    }
  },
  goToPage (e) {
    e.preventDefault()
    var page
    if (typeof $(e.currentTarget).data('page') !== 'undefined') { // Le data page est directement sur l'élément cliqué
      page = $(e.currentTarget).data('page')
    } else { // Il faut aller chercher le data-page sur l'option du select
      page = $(e.currentTarget).find(':selected').val()
    }
    if (typeof page !== 'undefined') {
      if ($('#page-ui').length) $('#page-ui').val(page)
      this.list(e)
    }
  },
  addSort (e) {
    if (!$('#tri-ui').length) console.warn('Attention, pas d\'indicateur de tri')
    var oldTri = $('#tri-ui').val()
    var oldTrid = $('#trid-ui').val()

    var tri = $(e.currentTarget).data('tri')
    var trid = $(e.currentTarget).data('trid')

    if (tri) {
      // Si on a deja trié sur ce champ alors on change l'ordre
      if (oldTri === tri) {
        trid = (oldTrid === 'asc' ? 'desc' : 'asc')
      } else {
        trid = 'desc'
      }

      $('#tri-ui').val(tri)
      $('#trid-ui').val(trid)

      if (typeof this.list === 'function') this.list()
    }
  },
  processSearch (e) {
    let code = e.which

    if (code === 13) {
      e.preventDefault()
      if (typeof this.list === 'function') {
        this.list(true, () => {
          $(this.defaultSearchElem)
            .focus() // donne le focus
            .val($(this.defaultSearchElem).val()) // pour mettre le focus à la fin du texte
        })
      }
    }
  },
  resetSearch (e) {
    if ($(this.defaultSearchElem).val()) {
      $(this.defaultSearchElem).val('')
      this.list(true)
    }
  },
  nextElement () {
    var idEl = $('#id_' + this.module).val()
    var row = $('.row-' + this.module + '[data-id=' + idEl + ']')
    if (row.length) {
      var next = row.next()
      if (next.length) {
        window.location.hash = '#!' + this.module + '/' + next.data('id')
      }
    }
  },
  previousElement () {
    var idEl = $('#id_' + this.module).val()
    var row = $('.row-' + this.module + '[data-id=' + idEl + ']')
    if (row.length) {
      var prev = row.prev()
      if (prev.length) {
        window.location.hash = '#!' + this.module + '/' + prev.data('id')
      }
    }
  },
  initButtonCheckbox () {
    $('.button-checkbox').each(function () {
      // Settings
      let $widget = $(this),
        $button = $widget.find('button'),
        $checkbox = $widget.find('input:checkbox'),
        color = $button.data('color'),
        settings = { on: { icon: 'glyphicon glyphicon-check' }, off: { icon: 'glyphicon glyphicon-unchecked' } }

      // Event Handlers
      $button.on('click', function () {
        $checkbox.prop('checked', !$checkbox.is(':checked'))
        $checkbox.triggerHandler('change')
        updateDisplay()
      })
      $checkbox.on('change', function () { updateDisplay() })

      // Actions
      function updateDisplay () {
        let isChecked = $checkbox.is(':checked')

        // Set the button's state
        $button.data('state', (isChecked) ? 'on' : 'off')

        // Set the button's icon
        $button.find('.state-icon').removeClass().addClass('state-icon ' + settings[$button.data('state')].icon)

        // Update the button's color
        if (isChecked) {
          $button.removeClass('btn-default').addClass('btn-' + color + ' active')
        } else {
          $button.removeClass('btn-' + color + ' active').addClass('btn-default')
        }
      }

      // Initialization
      function init () {
        updateDisplay()

        // Inject the icon if applicable
        if ($button.find('.state-icon').length === 0) {
          $button.prepend('<i class="state-icon ' + settings[$button.data('state')].icon + '"></i>')
        }
      }
      init()
    })
  },
  userModal (e) {
    if (e) e.preventDefault()
    $.ajax({
      url: '/user/profile',
      type: 'GET',
      data: { id: $(e.currentTarget).data('id-user') },
      complete: app.onComplete({
        success: (res) => {
          bootbox.dialog({
            message: require('./templates/user/modal')(res),
            onEscape: true,
            backdrop: true,
            closeButton: true,
            size: 'large'
          })
        }
      })
    })
  }
})
